import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const swimSchoolListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fswim-school.jpg?alt=media&token=a7387a73-9bda-4a98-ad0d-5ece9c7ca962",
  title: "Swim School",
  subtitle: "Pool Times & Team Scheduling Made Easy.",
  page: WildNavigationType.SWIMSCHOOLS,
}